import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconChevronRightOutline } from '@circlefin/euclid-icons/common';
import { ButtonCardCore } from '../ButtonCard.Core/ButtonCard.Core.es.js';

const ButtonCardButton = /*#__PURE__*/ forwardRef(({ className, variant, disabled, onClick, hideArrow, children, ...rest }, ref)=>jsx(ButtonCardCore, {
        className: className,
        disabled: disabled,
        variant: variant,
        children: jsxs("button", {
            ref: ref,
            disabled: disabled,
            onClick: !disabled ? onClick : undefined,
            ...rest,
            children: [
                jsx("div", {
                    children: children
                }),
                !hideArrow && jsx(IconChevronRightOutline, {
                    className: "arrow",
                    size: 16
                })
            ]
        })
    }));
ButtonCardButton.displayName = 'ButtonCard';

export { ButtonCardButton as default };
//# sourceMappingURL=ButtonCard.Button.es.js.map
